import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { AdminService } from 'src/app/admin-pages/admin.service';
import { LayoutService } from 'src/app/layout/layout.service';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'app-servicenear-settings',
  templateUrl: './servicenear-settings.component.html',
  styleUrls: ['./servicenear-settings.component.scss']
})
export class ServicenearSettingsComponent implements OnInit {
  loading: boolean = false;
  activeIndex: number = 0;
  isLoading: boolean = false;

  AccessoriesForm!: FormGroup;

  accessoriesProvided: any[] = [
    // { label: 'Battery', value: 'Battery' },
    // { label: 'Charger', value: 'Charger' },
    // { label: 'SIM', value: 'SIM' },
    // { label: 'MMC', value: 'MMC' },
    // { label: 'BothScrew', value: 'Bothscrew' },
  ];

  accessoriesMissing: any[] = [
    // { label: 'No Battery', value: 'NoBattery' },
    // { label: 'No Charger', value: 'NoCharger' },
    // { label: 'No SIM', value: 'NoSIM' },
    // { label: 'No SIM Tray', value: 'NoSIMTray' },
    // { label: 'No MMC', value: 'NoMMC' },
    // { label: 'One Screw Missing', value: 'NoOnescrew' },
    // { label: 'Both Screws Missing', value: 'NoBothscrew' },
    // { label: 'Dead', value: 'Dead' },
    // { label: 'Working', value: 'Working' },
  ];

  // for tost msg
  notificationMsg = '';
  showToast: boolean = false;
  isSuccess: boolean;
  branchInfo: any;
  page: number = 1;

  constructor(
    private fb: FormBuilder,
    public layoutService: LayoutService,
    private configService: ConfigService,
    private adminService: AdminService
  ) {}

  ngOnInit() {
    this.populateToolbarData();
    this.AccessoriesForm = this.fb.group({
      accessoriesProvided: this.fb.array([]),
      accessoriesMissing: this.fb.array([])
    });

    this.loadDefaultAccessories();
  }

  get accessoriesProvidedArray(): FormArray {
    return this.AccessoriesForm.get('accessoriesProvided') as FormArray;
  }

  get accessoriesMissingArray(): FormArray {
    return this.AccessoriesForm.get('accessoriesMissing') as FormArray;
  }

  // Load default values
  loadDefaultAccessories() {
    this.clearAccessories();
    this.configService.getSellerSettingsBySellerId({filters: "ThirdPartySettings"}).subscribe((res: any) => {
      if (res && res?.ResponseData && res?.ResponseData?.ThirdPartySettings) {
        const data = JSON.parse(res.ResponseData.ThirdPartySettings);
        const accessoriesConfig = JSON.parse(data.servicenear.accessoriesConfig);
        if(accessoriesConfig){
          this.accessoriesProvided = accessoriesConfig.accessoriesProvided || [];
          this.accessoriesMissing = accessoriesConfig.accessoriesMissing || [];
          this.accessoriesProvided.forEach(item => {
            this.accessoriesProvidedArray.push(this.createAccessory(item));
          });
          this.accessoriesMissing.forEach(item => {
            this.accessoriesMissingArray.push(this.createAccessory(item));
          });
        }else{
          this.accessoriesProvided = [];
          this.accessoriesMissing = [];
        }
      }else{
        this.accessoriesProvided = [];
        this.accessoriesMissing = [];
      }
    });

    
  }

  createAccessory(item?: any): FormGroup {
    return this.fb.group({
      label: [item?.label || ''],
      value: [item?.value || '']
    });
  }

  // Check if any accessory label is empty in either array
  hasEmptyAccessoryLabel(): boolean {
    const provided = this.accessoriesProvidedArray.controls.some(ctrl => !ctrl.get('label')?.value?.trim());
    const missing = this.accessoriesMissingArray.controls.some(ctrl => !ctrl.get('label')?.value?.trim());
    return provided || missing;
  }

  // Add new accessory
  addProvidedAccessory() {
    this.accessoriesProvidedArray.push(this.createAccessory());
  }

  addMissingAccessory() {
    this.accessoriesMissingArray.push(this.createAccessory());
  }

  // Remove accessory
  removeAccessory(index: number) {
    this.accessoriesProvidedArray.removeAt(index);
  }

  removeMissingAccessory(index: number) {
    this.accessoriesMissingArray.removeAt(index);
  }

  // Submit
  submit() {
    // Fill empty value with label (no spaces) if value is empty
    ['accessoriesProvided', 'accessoriesMissing'].forEach(arrayName => {
      const arr = this.AccessoriesForm.get(arrayName) as FormArray;
      arr.controls.forEach(ctrl => {
        const label = ctrl.get('label')?.value || '';
        const valueCtrl = ctrl.get('value');
        if (valueCtrl && (!valueCtrl.value || !valueCtrl.value.trim()) && label.trim()) {
          valueCtrl.setValue(label.replace(/\s+/g, ''));
        }
      });
    });

    let thirdPartyParams = {
      servicenear: {
        accessoriesConfig: JSON.stringify(this.AccessoriesForm.value)
      }
    }
    let payload : any= {}
    payload.thirdPartySettings = JSON.stringify(thirdPartyParams);
    this.adminService.updateSellerThemeDetails(payload).subscribe((res: any) => {
      if (res?.Result == "Success" && res?.ResponseData) {
        this.loadDefaultAccessories();
        this.configService.notify({ severity: 'success', summary: 'Success', detail: `Settings saved` });
      }
    }, (err: HttpErrorResponse) => {
      // this.isLoading = false;
    })
  }

  private populateToolbarData() {
    this.layoutService.setToolbar({
      title: 'Settings',
    });
    this.layoutService.setNavbarButtons([]);
  }

  public changePage(page: number) {
    this.page = page;
  }

  clearAccessories(){
    this.accessoriesProvidedArray.clear();
    this.accessoriesMissingArray.clear();
  }
}
